/* ════════════════════════════════════
   CAP LABS THEME — theme.js
════════════════════════════════════ */

/* PARTICLE CANVAS */
const canvas = document.getElementById('bgCanvas');
const ctx = canvas.getContext('2d');
let W, H, particles = [], mouse = { x: -999, y: -999 };

function resizeCanvas() {
  W = canvas.width = window.innerWidth;
  H = canvas.height = window.innerHeight;
}
resizeCanvas();
window.addEventListener('resize', resizeCanvas);

class Particle {
  constructor() { this.reset(); }
  reset() {
    this.x = Math.random() * W;
    this.y = Math.random() * H;
    this.size = Math.random() * 1.5 + 0.3;
    this.speedX = (Math.random() - 0.5) * 0.4;
    this.speedY = (Math.random() - 0.5) * 0.4;
    this.life = 0;
    this.maxLife = Math.random() * 200 + 100;
    this.color = Math.random() > 0.6 ? '#00f5ff' : Math.random() > 0.5 ? '#ff2d78' : '#8b5cf6';
    this.alpha = 0;
  }
  update() {
    this.x += this.speedX;
    this.y += this.speedY;
    this.life++;
    if (this.life < 20) this.alpha = this.life / 20;
    else if (this.life > this.maxLife - 20) this.alpha = (this.maxLife - this.life) / 20;
    const dx = this.x - mouse.x, dy = this.y - mouse.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist < 80) { this.x += (dx / dist) * 1.5; this.y += (dy / dist) * 1.5; }
    if (this.life > this.maxLife || this.x < 0 || this.x > W || this.y < 0 || this.y > H) this.reset();
  }
  draw() {
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fillStyle = this.color;
    ctx.globalAlpha = this.alpha * 0.55;
    ctx.fill();
  }
}

function drawConnections() {
  for (let i = 0; i < particles.length; i++) {
    for (let j = i + 1; j < particles.length; j++) {
      const dx = particles[i].x - particles[j].x;
      const dy = particles[i].y - particles[j].y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < 100) {
        ctx.beginPath();
        ctx.moveTo(particles[i].x, particles[i].y);
        ctx.lineTo(particles[j].x, particles[j].y);
        ctx.strokeStyle = '#00f5ff';
        ctx.globalAlpha = (1 - dist / 100) * 0.08;
        ctx.lineWidth = 0.5;
        ctx.stroke();
      }
    }
  }
}

const PARTICLE_COUNT = window.innerWidth < 768 ? 55 : 120;
for (let i = 0; i < PARTICLE_COUNT; i++) particles.push(new Particle());

function animCanvas() {
  ctx.clearRect(0, 0, W, H);
  drawConnections();
  particles.forEach(p => { p.update(); p.draw(); });
  ctx.globalAlpha = 1;
  requestAnimationFrame(animCanvas);
}
animCanvas();

document.addEventListener('mousemove', e => { mouse.x = e.clientX; mouse.y = e.clientY; });
document.addEventListener('touchmove', e => {
  const t = e.touches[0];
  mouse.x = t.clientX; mouse.y = t.clientY;
}, { passive: true });

/* 3D TILT CARD */
const tiltCard = document.getElementById('tiltCard');
if (tiltCard) {
  const tiltArea = tiltCard.parentElement;
  function applyTilt(x, y, rect) {
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const rx = ((y - cy) / (rect.height / 2)) * -14;
    const ry = ((x - cx) / (rect.width / 2)) * 14;
    tiltCard.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg)`;
  }
  tiltArea.addEventListener('mousemove', e => {
    applyTilt(e.clientX, e.clientY, tiltArea.getBoundingClientRect());
  });
  tiltArea.addEventListener('mouseleave', () => {
    tiltCard.style.transform = 'rotateX(0deg) rotateY(0deg)';
  });
  tiltArea.addEventListener('touchmove', e => {
    const t = e.touches[0];
    applyTilt(t.clientX, t.clientY, tiltArea.getBoundingClientRect());
  }, { passive: true });
  tiltArea.addEventListener('touchend', () => {
    tiltCard.style.transform = 'rotateX(0deg) rotateY(0deg)';
  });
}

/* MOBILE MENU */
function toggleMob() {
  const menu = document.getElementById('mMenu');
  const ham = document.getElementById('ham');
  if (menu && ham) {
    menu.classList.toggle('open');
    ham.classList.toggle('open');
  }
}
function closeMob() {
  const menu = document.getElementById('mMenu');
  const ham = document.getElementById('ham');
  if (menu) menu.classList.remove('open');
  if (ham) ham.classList.remove('open');
}

/* SEARCH */
function openSrch() {
  document.getElementById('sOv').classList.add('open');
  setTimeout(() => { const el = document.getElementById('sIn'); if (el) el.focus(); }, 300);
}
function closeSrch() {
  document.getElementById('sOv').classList.remove('open');
}

/* CART DRAWER */
function openCart() {
  document.getElementById('cDr').classList.add('open');
  document.getElementById('cOv').classList.add('open');
}
function closeCart() {
  document.getElementById('cDr').classList.remove('open');
  document.getElementById('cOv').classList.remove('open');
}

/* TOAST */
let toastTimer;
function showToast(msg, sub) {
  const t = document.getElementById('toast');
  document.getElementById('tmsg').textContent = msg;
  const sub_el = t.querySelector('.t-s');
  if (sub_el) sub_el.textContent = sub || 'View cart to checkout';
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 2800);
}

/* ADD TO CART via Shopify AJAX API */
function addToCart(variantId, productName, quantity) {
  quantity = quantity || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(r => r.json())
  .then(data => {
    if (data.status === 422 || data.description) {
      showToast('Could not add to cart', data.description || 'Item unavailable');
      return;
    }
    showToast((productName || 'Item') + ' added!', 'Open cart to checkout');
    refreshCart();
  })
  .catch(() => {
    showToast('Added to cart!', 'Open cart to checkout');
  });
}

/* UPDATE CART ITEM */
function updateCart(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(r => r.json())
  .then(() => refreshCart());
}

/* REFRESH CART DRAWER */
function refreshCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      // Update cart count badges
      document.querySelectorAll('#navCartCount, #cartCount').forEach(el => {
        el.textContent = cart.item_count + (el.id === 'cartCount' ? ' items' : '');
      });
      // Update subtotal
      const sp = document.querySelector('.c-sp');
      if (sp) sp.textContent = formatMoney(cart.total_price);
      // Refresh cart items HTML
      fetch('/cart?view=drawer')
        .then(r => r.text())
        .catch(() => {});
    });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* SCROLL REVEAL */
function initReveal() {
  const io = new IntersectionObserver(entries => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('vis'), i * 55);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.07 });
  document.querySelectorAll('.reveal:not(.vis)').forEach(el => io.observe(el));
}
document.addEventListener('DOMContentLoaded', initReveal);

/* VIEW TOGGLE (collection page) */
document.querySelectorAll('.vbtn').forEach(b => b.addEventListener('click', function () {
  document.querySelectorAll('.vbtn').forEach(x => x.classList.remove('on'));
  this.classList.add('on');
  const grid = document.getElementById('productGrid');
  if (grid) {
    if (this.textContent.includes('☰')) {
      grid.style.gridTemplateColumns = '1fr';
    } else {
      grid.style.gridTemplateColumns = '';
    }
  }
}));

/* NAV SCROLL */
window.addEventListener('scroll', () => {
  const g = document.querySelector('.nav-glass');
  if (g) g.style.background = window.scrollY > 10 ? 'rgba(4,4,10,.97)' : 'rgba(4,4,10,.88)';
}, { passive: true });

/* KEYBOARD SHORTCUTS */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { closeSrch(); closeCart(); closeMob(); }
  if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); openSrch(); }
});
